import {
  GroupRoleListReq,
  GroupRoleListRsp,
  GetCreateRoleConfigReq,
  GetCreateRoleConfigRsp,
  MyRoleListReq,
  MyRoleListRsp,
} from '../../typings/proto';
import Net from '../../util/net';
export default {
  /**
   * 获取角色基础信息
   * @param groupId
   */
  getGroupRoleList(groupId: string): Promise<GroupRoleListRsp> {
    return Net.request<GroupRoleListRsp, GroupRoleListReq>({
      path: 'knockknock.RbacSrv/GetGroupRoleList',
      data: {
        groupId,
      },
    });
  },
  /**
   * 获取创建角色的相关配置
   * @param groupId
   */
  getCreateRoleConfig(groupId: string): Promise<GetCreateRoleConfigRsp> {
    return Net.request<GetCreateRoleConfigRsp, GetCreateRoleConfigReq>({
      path: 'knockknock.RbacRoleSrv/GetCreateRoleConfig',
      data: {
        gid: groupId,
      },
    });
  },
  /**
   * 获取用户角色列表
   * @param groupId
   */
  getMyRoleList(groupId: string): Promise<MyRoleListRsp> {
    return Net.request<MyRoleListRsp, MyRoleListReq>({
      path: 'knockknock.RbacSrv/GetMyRoleList',
      data: {
        groupId,
      },
    });
  },
};
